module.exports = __webpack_public_path__ + "img/logotipo.435ef4e8.svg";